import Cookies from 'js-cookie';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const useAuthenticationStore = create()(
  devtools((set) => ({
    login: Cookies.get('logedIn'),
    loading: false,
    error: null,
    doLogin: (login) => {
      set({ login, loading: false }, false, 'doLogin');
      Cookies.set('logedIn', true);
    },
    setLoading: (loading) => set({ loading }, false, 'setLoading'),
    doLogout: () => {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      Cookies.remove('user_id');
      Cookies.remove('user_email');
      set({ login: false, loading: false }, false, 'doLogout');
    },
  })),
);
